const scrollTo = (element, offset = 0, behavior = 'smooth') => {
    const yOffset = offset
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
    window.scrollTo({ top: y, behavior: behavior })
}

export default scrollTo
